module.exports = Mustache;


//////////////////
// WEBPACK FOOTER
// external "Mustache"
// module id = 546
// module chunks = 2